import { Rise } from "@/components/humble/AnimatedText";
import ChapterMark from "@/components/humble/ChapterMark";
import Painting from "@/components/humble/Painting";
import { HUMBLE } from "@/constants/testIds";

export default function OriginStory() {
  return (
    <section
      id="origin"
      data-testid={HUMBLE.originSection}
      className="relative isolate overflow-hidden bg-cream text-earth"
    >
      <ChapterMark numeral="I" label="Why we started" />
      <div className="relative z-[1] mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-14 px-6 py-28 md:px-12 md:py-40 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5 lg:sticky lg:top-24 self-start">
          <Rise>
            <div className="mb-6 flex items-center gap-3 font-body uppercase text-[11px] tracking-[0.42em] text-earth/60">
              <span className="inline-block h-px w-8 bg-earth/40" />
              Chapter I
            </div>
            <h2 className="font-display text-4xl leading-[1.06] tracking-tight text-earth md:text-5xl lg:text-[56px]">
              We moved to the hills, and slowly the homestead grew larger than
              our memory.
            </h2>
          </Rise>
          <Rise delay={0.15}>
            <p className="mt-6 max-w-md font-hand text-2xl text-earth/70">
              our family <span aria-hidden>—</span>
            </p>
          </Rise>
        </div>

        <div className="lg:col-span-7">
          <Rise>
            <div className="overflow-hidden rounded-[6px]">
              <Painting
                src="/art/origin-family-porch.png"
                alt="A painted homestead porch at late afternoon light."
                wrapperClassName="aspect-[4/3]"
                kenBurns={false}
              />
            </div>
          </Rise>
          <div className="mt-10 max-w-xl space-y-6 font-body text-[17px] leading-relaxed text-earth/85 md:text-lg">
            <Rise delay={0.1}>
              <p className="first-letter:font-display first-letter:text-[64px] first-letter:mr-2 first-letter:float-left first-letter:leading-[0.85] first-letter:text-earth">
                In 2020 our family moved to rural Arkansas to live off-grid and
                follow the Lord, raising our kids close to the land. We keep
                chickens, goats, sheep, and one heifer.
              </p>
            </Rise>
            <Rise delay={0.18}>
              <p>
                It began small. The kids started keeping their own animal
                records — our oldest, our son, even built a little system of
                his own. That&rsquo;s when their dad realized he had no clear
                picture across the whole homestead: who was due, who was
                treated, which hen was sitting, what the chore list even was
                that morning.
              </p>
            </Rise>
            <Rise delay={0.24}>
              <p className="text-earth/80">
                Humble Roots is the tool he wished he&rsquo;d had — one calm,
                simple place that holds the animals and their records, health
                and treatments, breeding, and the daily chores. Built for
                families who also work an outside job.
              </p>
            </Rise>
          </div>
        </div>
      </div>

      {/* soft dawn-to-day color grade transition */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-40"
        style={{
          background:
            "linear-gradient(180deg, transparent 0%, hsl(var(--parchment)) 100%)",
        }}
      />
    </section>
  );
}
